module.exports = __webpack_public_path__ + "static/media/catering-services.dfdb6135.webp";